import React  from 'react';
import * as SharedAcross from './Common/SharedAcross';
import GeogMap from './GeogMap';
import Youtube from './Youtube';
import DragAndDrop from './DragAndDrop';
import Box from './Box';
import Dustbin from './Dustbin';

function App(props) {

  var highlightColor = "#FFEDD9";

  var treeVIn = props.tree;
  var position = props.position;
  var selectPosition = props.selectPosition;
  var startLevelsArray = props.startLevelsArray;
  var width = props.width;
  var interactionType = props.interactionType;
  var selectPositionWithSubAction = props.selectPositionWithSubAction;

  var posString = position.map((aPosition, index)=>{
      return aPosition.v;
    }).join(" ");


  function getTextIfStringElseFalse(item){
    var itemType = item.v[8];
    if (itemType.t === "tuple"){
      if (itemType.v[0].v === "string"){
        return itemType.v[1].v;
      }
    }
    return false;
  }

  function calcValue(valuePiece, startArray){
    var piece = valuePiece.v;
    var typeIndicator = piece[0].v;
    var itemType = piece[8];
    var children = piece[2].v;
    
    var expressionPiece = itemType.v[1].v;

    if (expressionPiece=== 74){ //ifthenelse
      var insetHere = null;
      var newPositionTrue = startArray.concat([1]).join(" ");
      var newPositionFalse = startArray.concat([2]).join(" ");
      if (posString.indexOf(newPositionTrue) === 0){
        insetHere = calcValue(children[1], startArray.concat([1]));
      }else if (posString.indexOf(newPositionFalse) === 0){
        insetHere = calcValue(children[1], startArray.concat([2]));
      }
      if (typeIndicator === 15){
        return <div>If Then Else<br/>{insetHere}</div>
//
      }else{
        return insetHere;
      }
//              
    }else if (typeIndicator === 2){ //number
      if (piece[8].t === "tuple"){
        if (piece[8].v[0].v === "integer"){
          return piece[8].v[1].v;
        }
      }
      return 0;
    }else if (typeIndicator === 12){ //list
      if (piece[8].t === "tuple"){
        if (piece[8].v[0].v === "k"){
          if (piece[8].v[1].v === 62){ //list by adding individual pieces;
            return [children.map((aPiece, index)=>{
              return calcValue(aPiece, startArray.concat([+index]));
            })]
          }else if (piece[8].v[1].v === 64){ //list by combining two lists;
            var a = calcValue(children[0], startArray.concat([0]))
            var b = calcValue(children[1], startArray.concat([1]));
            return a.concat(b);
          } 
        }
      }
      return [];
    }else if (typeIndicator === 13){ //string
      if (piece[8].t === "tuple"){
        if (piece[8].v[0].v === "string"){
          return piece[8].v[1].v;
        }
      }
      return "";
    }else if (typeIndicator === 16){ //decimal
      if (piece[8].t === "tuple"){
        if (piece[8].v[0].v === "decimal"){
          return piece[8].v[1].v;
        }
      }
      return 0;
    }else if (typeIndicator === 174){ //distances
      var typeOfDistanceMeasure = valuePiece.v[8];
      var val = calcValue(children[0], startArray.concat([0]));
      if (typeOfDistanceMeasure.t === "tuple"){
        if (typeOfDistanceMeasure.v[0].v === "k"){
          if (typeOfDistanceMeasure.v[1].v === 176){ //percentages
            if (val > -1){
              return val + "%";
            }
          }else if (typeOfDistanceMeasure.v[1].v === 177){ //pixels
            if (val > -1){
              return val + "px";
            }
          }
        }
      }

    }else if (typeIndicator === 35){ //colours
      var typeOfColourMeasure = piece[8];
      if (typeOfColourMeasure.t === "tuple"){
        if (typeOfColourMeasure.v[0].v === "k"){
          if (typeOfColourMeasure.v[1].v === 119){
            return "red";
          }else if (typeOfColourMeasure.v[1].v === 120){
            return "green";
          }else if (typeOfColourMeasure.v[1].v === 121){
            return "blue";
          }
        }else if (typeOfColourMeasure.v[0].v === "colorWheel"){
          return typeOfColourMeasure.v[1].v;
        }
      }

    }else if (typeIndicator === 142){ //alignment
      var typeOfColourMeasureA = piece[8];
      if (typeOfColourMeasureA.t === "tuple"){
        if (typeOfColourMeasureA.v[0].v === "k"){
          if (typeOfColourMeasureA.v[1].v === 203){
            return "left";
          }else if (typeOfColourMeasureA.v[1].v === 204){
            return "center";
          }else if (typeOfColourMeasureA.v[1].v === 205){
            return "right";
          }
        }
      }


    }else if (typeIndicator === 15 && expressionPiece !== 63){ //html.
      if (itemType.t === "tuple"){
        if (itemType.v[0].v === "k"){


          var stylingArray0 = startArray.concat([0]);
          var startArrayString0 = stylingArray0.join(" ");
          var startStyle = {};
          if (posString.indexOf(startArrayString0) === 0){
            startStyle.backgroundColor = highlightColor;
          }
//
          if (itemType.v[1].v === 25){ //image
            // var src = getTextIfStringElseFalse(children[0]);
            var style = evaluateStyles(children[0], startStyle, startArray);
            var src = style.src;
            if (!src){
              src = "/client_pictures/trophy.png";
            }
            return <img alt="" className="treeLine" src={src} style={style} onClick={fakePosString(stylingArray0)}/>
          }else if (itemType.v[1].v === 68){ //textBox
            var style1 = evaluateStyles(children[0], startStyle, startArray);
            var text = style1.text;
            if (!text){
              text = "Hello";
            }
            return <div style={style1} className="treeLine" onClick={fakePosString(stylingArray0)}>{text}</div>
  //          
          }else if (itemType.v[1].v === 69){ //break
            return <div onClick={fakePosString(stylingArray0)} className="treeLine" style={startStyle}><br/></div>
  //            
          }else if (itemType.v[1].v === 70){ //hyperlink
            var style000 = evaluateStyles(children[0], startStyle, startArray);
            var link = style000.url;
            if (!link){
              link = "https://www.google.com";
            }

            var linkText = style000.text;
            if (!linkText){
              linkText = "click here";
            }
            return <span>
                      <button className="linkButton" onClick={SharedAcross.openUrl(link)}>{linkText}</button>
                      <span onClick={fakePosString(stylingArray0)} className="treeLine" style={{color:"#CCC"}}>Edit Link</span>
                    </span>
  //          
          }else if (itemType.v[1].v === 71){ //header
            startStyle.fontSize = "1.5em";
            var style3 = evaluateStyles(children[0], startStyle, startArray);
            var text1 = style3.text;
            if (!text1){
              text1 = "Header";
            }
            return <div style={style3} className="treeLine" onClick={fakePosString(stylingArray0)}><b>{text1}</b></div>
  //          
  //          
          }else if (itemType.v[1].v === 75){ //geogMap
            startStyle.textAlign = "right";
            var style30 = evaluateStyles(children[0], startStyle, startArray);
             return <div style={style30}><button onClick={fakePosString(stylingArray0)}>Edit</button><br/><GeogMap points={style30.location} width={width} /></div>
//
          }else if (itemType.v[1].v === 103){ //youtube
            var style300 = evaluateStyles(children[0], startStyle, startArray);
            var vidLocation = style300.url;
            return <div style={style300}><button onClick={fakePosString(stylingArray0)}>Edit</button><br/><Youtube contents={vidLocation}/></div>
//
          }else if (itemType.v[1].v === 63){ //list containing
            var p = calcValue(children[0], startArray.concat([0]));
            return <div>{p}</div>
  //          
          }
//
      }
    }
//
    return false;
  }else if (typeIndicator === 14 || expressionPiece === 63 ){ //html overall. 63 is div.
    if (itemType.t === "tuple"){
      if (itemType.v[0].v === "k"){
        if (expressionPiece === 65 || expressionPiece === 63){
          var childrenPieces = [];
          children[0].v[2].v.map((aChild, index)=>{

            childrenPieces.push(<Dustbin key={"d"+index} whereToInsert={startArray.concat([0])} insertPosition={+index} dustbinText=""/>);
            childrenPieces.push(calcValue(aChild, startArray.concat([0, +index])));
            return null;
          })

          var style4 = evaluateStyles(children[1], {textAlign:"center", border:"solid 1px #CCC", padding:"5px"}, startArray.concat([1]));

          var stylingArray = startArray.concat([1]);
          var startArrayString = stylingArray.join(" ");
          var editPiece = null;
          var style40 = {padding:"5px", textAlign:"right"};
          if (posString.indexOf(startArrayString) === 0){
            style40.backgroundColor = highlightColor;
          }else{
            editPiece = <span onClick={fakePosString(stylingArray)} className="treeLine" style={{color:"#CCC"}}>Edit Box</span>
          }
//

          var topLine;
          var dustbinText = "";
          var currentChildren = children[0].v[2].v;
          if (currentChildren.length > 0){
            topLine = <div style={{color:"#CCC"}}>Click component to Edit</div>
//
          }else{
            dustbinText = "Drag a component into the box"
          }
//
          var startHere = <div width={width} style={style40} >
                  {editPiece}
                  <div width={width - 10} style={style4}>
                    {childrenPieces}
                    <Dustbin key={"ddd"} whereToInsert={startArray.concat([0])} insertPosition={-1} dustbinText={dustbinText}/>
                </div>
            </div>

          var dragDropPiece = null;
          if (expressionPiece === 65){
            var pieces = [{n:"Text",t:68},{n:"Image",t:25},{n:"Box with Elements",t:63},{n:"Hyperlink",t:70},{n:"Break",t:69},{n:"Header",t:71},{n:"Youtube",t:103}];
            // {n:"Map",t:75},
            var converted = SharedAcross.convertToGrid(pieces, 6, true);
            var rows = converted.map((aRow, index)=>{
              var cells = aRow.map((aCell, index0)=>{
                if (aCell){
                  return <td key={index0}><Box name={aCell.n} coqTermID={aCell.t} selectPositionWithSubAction={selectPositionWithSubAction}/></td>
          //
                }else{
                  return <td key={index0}></td>
                }
              });
              return <tr key={index}>{cells}</tr>
          //
            });

            dragDropPiece = <table style={{padding:"5px",width:"100%"}}><tbody>
                        {rows}
                      </tbody></table> 

          }
            return <DragAndDrop>
                      {dragDropPiece}
                      {startHere}
                      {topLine}
                    </DragAndDrop>


          } 
    //
        }
      }
    }
  }

//  
  function evaluateStyles(styleSet, originalStyle, startArray){
    var stylePieces = styleSet.v[2].v;
    for (var i = 0; i < stylePieces.length; i++){
      var aPiece = stylePieces[i];
      var whichStyleAttribute = aPiece.v[8];
      if (whichStyleAttribute.t === "tuple"){
        if (whichStyleAttribute.v[0].v === "htmlStyle"){
          var thisAttribute = whichStyleAttribute.v[2].v;
          var valuePiece = aPiece.v[2].v[0];
          if (thisAttribute === "text"){
            var text1 = getTextIfStringElseFalse(valuePiece);
            if (text1 === false){
              text1 = "[Text Based on a function]";
            }
            originalStyle[thisAttribute] = text1;
          }else if (thisAttribute === "src"){
            var src = getTextIfStringElseFalse(valuePiece);
            if (src === false){
              src = "/client_pictures/file.png";
            }
            originalStyle[thisAttribute] = src;
          }else if (thisAttribute === "url"){
            var src0 = getTextIfStringElseFalse(valuePiece);
            originalStyle[thisAttribute] = src0;
          }else if (thisAttribute === "location"){
            var points = calcValue(valuePiece, startArray.concat([0]));
            var points1 = points.map((aPoint, index)=>{
              return {lat:aPoint[0], long:aPoint[1], name:aPoint[2], details:aPoint[3]};
            })
            originalStyle[thisAttribute] = points1;

          }else{
            var value = calcValue(valuePiece, startArray.concat([+i]));
            if (value){
              originalStyle[thisAttribute] = value;
            }
          }
        }
      }      
    }
    return originalStyle;
  }

  function fakePosString(startArray){
    return function(e){
      if (interactionType === 1){
        selectPosition(startArray);
      }else{
        selectPosition(startArray.concat([-1]));
      }
    }
  }
  var startPiece = calcValue(treeVIn, startLevelsArray);
  return startPiece;

}

export default App;

